import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './Toggle.module.scss';

export const Toggle = ({
  name,
  className,
  inputProps,
  disabled = false,
  dataTestId,
  register = () => {},
}) => {
  return (
    <div className={cn(styles.slider, { [className]: className })}>
      <input
        disabled={disabled}
        type="checkbox"
        {...register(name)}
        {...inputProps}
        data-testid={dataTestId}
      />
      <span></span>
    </div>
  );
};

Toggle.propTypes = {
  register: PropTypes.func,
  name: PropTypes.string,
  className: PropTypes.string,
  inputProps: PropTypes.object,
};
